import { Button, Icons, Typography } from "@pankod/refine-antd";
import { useNavigation } from "@pankod/refine-core";
const { Title } = Typography;

const BackTitle = ({ title }: { title: string }) => {
    const { goBack } = useNavigation();
    return (
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <Button type="link"
                icon={<Icons.ArrowLeftOutlined
                    style={{ cursor: 'pointer', color: "black", fontSize: "16px" }}
                />}
                onClick={() => goBack()} />
            <Title level={4} style={{ margin: 0 }}>{title}</Title>
        </div>
    );
};
export default BackTitle;